module.exports = __webpack_public_path__ + "media/images/area/icon_weather_11-9f2b02d17fa63b5d17797c2d627998ec.png";